import React, { useEffect, useState } from 'react';
import styles from './scheduleInviteModal.module.scss';
import { useActions, useAppSelector, ScheduleActions } from '@web-common/state/createStore';
import { getIn18Text, isEdm } from 'api';
import SiriusModal from '@web-common/components/UI/SiriusModal';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import ContactScheduleModal from '@web-common/components/UI/SiriusContact/scheduleModal';
import { addMoreInvitees } from '@web-schedule/service';
import Button from '@lingxi-common-component/sirius-ui/Button';
const ScheduleInviteModal = ({ onCancel }) => {
    const [canSave, setCanSave] = useState(false);
    const [loading, setLoading] = useState(false);
    const [invitee, setInvitee] = useState([]);
    const { scheduleEvent } = useAppSelector(state => state.scheduleReducer);
    const actions = useActions(ScheduleActions);
    const syncSchedule = async () => {
        SiriusMessage.success({ content: getIn18Text('FASONGCHENGGONG') });
        actions.syncSchedule({ type: 'update' });
    };
    const handleOk = async () => {
        setLoading(true);
        try {
            await addMoreInvitees(scheduleEvent, invitee.map(item => item.email));
            syncSchedule();
            handleCancel();
        }
        catch (error) {
            console.error('addMoreInvitees error', error);
        }
        finally {
            setLoading(false);
        }
    };
    const handleCancel = () => {
        onCancel && onCancel();
    };
    useEffect(() => { }, []);
    const handleChange = (item) => {
        setCanSave((item === null || item === void 0 ? void 0 : item.length) > 0);
        setInvitee(item || []);
    };
    return (React.createElement(SiriusModal, { className: styles.container, visible: !!scheduleEvent, cancelText: getIn18Text('QUXIAO'), closable: false, okButtonProps: { disabled: !canSave, target: getIn18Text('FASONG') }, onOk: handleOk, onCancel: handleCancel, wrapClassName: styles.container, isGlobal: true, bodyStyle: { overflow: 'auto' }, okText: getIn18Text('FASONG'), footer: React.createElement("div", { className: styles.deFooter },
            React.createElement(Button, { btnType: "minorLine", onClick: handleCancel }, getIn18Text('QUXIAO')),
            React.createElement(Button, { btnType: "primary", onClick: handleOk, loading: loading, disabled: !canSave || loading }, getIn18Text('FASONG'))) },
        React.createElement("div", { className: styles.title }, getIn18Text('ZHUANFARICTJGDSYR')),
        React.createElement(ContactScheduleModal, { includeSelf: true, onChange: handleChange, useEdm: isEdm(), type: isEdm() ? ['customer', 'personal', 'enterprise', 'team', 'recent'] : ['personal', 'enterprise', 'team', 'recent'], dropdownClassName: styles.selectDropDown, listItemHeight: 30, placeholder: getIn18Text('deliveryPlaceholder'), showSuffix: true, modalProps: {
                zIndex: 1050,
                maskStyle: {},
            } })));
};
export default ScheduleInviteModal;
